<template>
  <div class="site-btn-box">
    <v-btn class="site-btn" @btnClick="on_click">
      {{ $TL.goTopic }}
      <v-icon>chevron_right</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  methods: {
    on_click() {
      let customRoutes = this.$router.options.routes;
      let currentIndex = 0;
      customRoutes.map((item, i) => {
        if (item.name === this.$route.name) currentIndex = i;
      });

      this.$router.push({ path: customRoutes[currentIndex + 1].path });
    },
  },
};
</script>

<style lang="scss">
.site-btn-box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  margin-top: 64px;
  .site-btn {
    font-size: 18px;
    background-color: #fff;
    opacity: 0.8;
    padding: 12px 32px;
    border-radius: 54px;
    transition: 0.3s;
    position: relative;

    i {
      margin-left: 4px;
      color: #fff !important;
      position: absolute;
      right: 5px;
      top: 50%;
      transform: translateY(-50%);
      opacity: 0.8;
      padding: 0;
    }

    &:hover,
    &:active {
      background: #f0bb44;
      opacity: 0.9;
      i {
        color: #000 !important;
        opacity: 0.9;
      }
    }

    &:active {
      opacity: 0.8;
    }
  }
}
@media (max-width: $lx-min) {
  .site-btn {
    font-size: 16px;

    i {
      font-size: 22px;
    }
  }
}

body.rtl {
  .site-btn-box {
    .site-btn {
      i {
        margin-right: 4px;
        margin-left: inherit;
        right: auto;
        left: 5px;
        transform-origin: center;
        transform: rotateZ(180deg) translateY(50%);
      }
    }
  }
}
</style>
